import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "lottery-card-wrapper" }

import { computed, ref, onMounted, onUnmounted, watch } from 'vue';
import { useRouter, useRoute } from 'vue-router';
import { useTheme } from '@/composables/useTheme';
import type { UpcomingDraw } from '@/types/lottery';


// Sub-components
import HorizontalLotteryCard from './cards/HorizontalLotteryCard.vue';
import VerticalLotteryCard from './cards/VerticalLotteryCard.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'LotteryCard',
  props: {
    lottery: {},
    layout: {},
    isFavorited: { type: Function }
  },
  emits: ["bet", "favorite", "remove"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const router = useRouter();
const route = useRoute();
const { getAssetPath } = useTheme();

// Derived Props
const currentLayout = computed(() => props.layout || 'horizontal');

// Assets
const favoriteIcon = getAssetPath('icons', 'favorite') || '/img/icons/favorite.svg';
const favoriteFilledIcon = getAssetPath('icons', 'favorite-filled') || '/img/icons/favorite-filled.svg';

// State
const betClosed = ref(false);
const countdown = ref({
  hours: 0,
  minutes: 0,
  seconds: 0
});

// Logic
const isFavoritedProp = computed(() => {
  return typeof props.isFavorited === 'function' ? props.isFavorited(props.lottery) : false;
});

const updateCountdown = () => {
  if (!props.lottery?.cutoff) {
    countdown.value = { hours: 0, minutes: 0, seconds: 0 };
    return;
  }
  const now = new Date();
  const cutoffRaw = props.lottery.cutoff as string | Date;
  const cutoffTime = typeof cutoffRaw === 'string'
    ? new Date(cutoffRaw.replace(' ', 'T'))
    : new Date(cutoffRaw);
  const diff = cutoffTime.getTime() - now.getTime();

  if (diff <= 0) {
    countdown.value = { hours: 0, minutes: 0, seconds: 0 };
    return;
  }

  countdown.value = {
    hours: Math.floor(diff / (1000 * 60 * 60)),
    minutes: Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60)),
    seconds: Math.floor((diff % (1000 * 60)) / 1000)
  };
};

let timer: number;

onMounted(() => {
  updateCountdown();
  timer = window.setInterval(updateCountdown, 1000);
});

onUnmounted(() => {
  if (timer) {
    clearInterval(timer);
  }
});

const toggleFavorite = () => {
  emit('favorite');
};

const handleBet = () => {
  emit('bet');
};

const navigateToDetail = () => {
  if (props.lottery?.game_slug) {
    router.push({ path: `/lottery/${props.lottery.game_slug}`, query: route.query });
  }
};

watch(
  () => [countdown.value.hours, countdown.value.minutes, countdown.value.seconds],
  ([hours, minutes, seconds]) => {
    if (hours === 0 && minutes === 0 && seconds === 0 && !betClosed.value) {
      betClosed.value = true;
      setTimeout(() => {
        emit('remove');
      }, 3000);
    }
  }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_Transition, {
      name: "fade",
      mode: "out-in"
    }, {
      default: _withCtx(() => [
        (currentLayout.value === 'horizontal')
          ? (_openBlock(), _createBlock(HorizontalLotteryCard, {
              key: 0,
              lottery: _ctx.lottery,
              "is-favorited": isFavoritedProp.value,
              countdown: countdown.value,
              "favorite-icon": _unref(favoriteIcon),
              "favorite-filled-icon": _unref(favoriteFilledIcon),
              onFavorite: toggleFavorite,
              onNavigate: navigateToDetail
            }, null, 8, ["lottery", "is-favorited", "countdown", "favorite-icon", "favorite-filled-icon"]))
          : (_openBlock(), _createBlock(VerticalLotteryCard, {
              key: 1,
              lottery: _ctx.lottery,
              "is-favorited": isFavoritedProp.value,
              countdown: countdown.value,
              "favorite-icon": _unref(favoriteIcon),
              "favorite-filled-icon": _unref(favoriteFilledIcon),
              "bet-closed": betClosed.value,
              onFavorite: toggleFavorite,
              onBet: handleBet,
              onNavigate: navigateToDetail
            }, null, 8, ["lottery", "is-favorited", "countdown", "favorite-icon", "favorite-filled-icon", "bet-closed"]))
      ]),
      _: 1
    })
  ]))
}
}

})